export const BackHandler = {
  isTransactionLoaderShowing: false,
}
